import List from 'list.js'

if (jQuery('.score__tab__skills .list').length !== 0) {

    var scores_list = new List('scores__skills', {
        valueNames : [
            { data : [ 'age', 'gender', 'skill', 'type' ] }
        ]
    })

}

jQuery('.score__select select').on( 'change', updateList )

jQuery( '.score__level' ).on( 'click', function() {
    let showTab = jQuery(this).attr('id')

    jQuery( '.score__level' ).each( function() {
        jQuery(this).removeClass('score__level--active')
        jQuery(this).removeClass('score__level--skills')
    })

    if ( showTab == 'score__tab__skills' ) {

        jQuery( '.score__filter' ).removeClass('hidden')
        jQuery(this).addClass('score__level--skills')
        jQuery( '.score__tabs' ).addClass( 'score__tabs--no-margin' );

    } else {

        jQuery(this).addClass('score__level--active')
        jQuery( '.score__filter' ).addClass('hidden')
        jQuery( 'score__tabs' ).removeClass( 'score__tabs--no-margin' );

    }

    jQuery( '.score__tab' ).addClass('hidden')

    if ( showTab == 'score__tab__skills' )
        jQuery( '.' + showTab ).removeClass('hidden')
    else
        jQuery( '.' + showTab ).removeClass('hidden').addClass('score__tab--active')
})

jQuery( '.nav-dropdown-scores select' ).on( 'change', function() {
    let value = jQuery('option:selected', this).val();
    let showTab = 'score__tab__' + value

    jQuery( '.score__tab' ).addClass('hidden')

    if ( showTab == 'score__tab__skills' ) {
        jQuery( '.' + showTab ).removeClass('hidden')
        jQuery( '.score__filter' ).removeClass('hidden')
    }
    else {
        jQuery( '.' + showTab ).removeClass('hidden').addClass('score__tab--active')
        jQuery( '.score__filter' ).addClass('hidden')
    }
})

function updateList() {
    let age = jQuery('#score_age option:selected').val();
    let gender = jQuery('#score_gender option:selected').val();
    let skill = jQuery('#score_skill option:selected').val();
    let type = jQuery('#score_type option:selected').val();

    if ( age == 'all' )
        age = null
    if ( gender == 'all' )
        gender = null
    if ( skill == 'all' )
        skill = null
    if ( type == 'all' )
        type = null

    scores_list.filter( function(item) {
        return ( _(age).includes( item.values().age ) || !age ) && ( _(gender).includes( item.values().gender ) || !gender ) && ( _(skill).includes( item.values().skill ) || !skill ) && ( _(type).includes( item.values().type ) || !type );
    })
}
